import { useCallback } from 'react'
import { HomeNavigationLinkProps } from './types'
import { NavigationDrawer } from '@/features/navigation/components/NavigationDrawer'
import { useNavigationDrawerContext } from '../NavigationDrawer'
import { MenuItem } from '@/features/header/components/Header/types'

export const HomeNavigationLink: React.FC<HomeNavigationLinkProps> = ({
  menuItem,
}) => {
  const { setActiveItem } = useNavigationDrawerContext()
  const isDirectLink = menuItem.sub_links.length === 0 && menuItem.url

  if (isDirectLink) {
    return (
      <NavigationDrawer.Link
        key={menuItem.title}
        as="a"
        href={menuItem.url}
        className="w-full"
        variant="title-five"
      >
        {menuItem.title}
      </NavigationDrawer.Link>
    )
  }

  const handleNavigationClick = useCallback(
    (item: MenuItem) => () => {
      setActiveItem(item.title)
    },
    [setActiveItem],
  )

  return (
    <NavigationDrawer.Link
      as="button"
      className="w-full"
      onClick={handleNavigationClick(menuItem)}
      paginate="next"
      variant="title-five"
    >
      {menuItem.title}
    </NavigationDrawer.Link>
  )
}
